import { DataHeader, DataSource, Layout, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCheckCallSchedule extends Layout {
    dataheaderD: DataHeader;
    sourceCheckCallSchedule: DataSource;
    sourceFixedTimeCall: DataSource;
    sourceRecurringCheckCall: DataSource;
    tabFixedTimes: Tab;
    tabRecurringCheckCalls: Tab;
    tableFixedTimes: Table;
    tableRecurring: Table;
    tabsetTabs: Tabset;
    textboxCommodityId: Textbox;
    textboxCustomerId: Textbox;
    textboxDescr: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxId: Textbox;
    textboxSchedType: Textbox;
}
